// extracted by mini-css-extract-plugin
module.exports = {"modal":"ImageDetailModal_modal__KKpWv","backdrop":"ImageDetailModal_backdrop__3aOWX","closeIcon":"ImageDetailModal_closeIcon__20B0W"};